/* eslint-disable no-useless-constructor */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Button, Col, Input, Modal, Row, Form, message } from "antd";
import logo_Final from "../images/design/logoHeader.svg";
import { colors } from "../constants/colors";
// import { MailOutlined, LockOutlined } from "@ant-design/icons";
import FormItem from "antd/lib/form/FormItem";
import EyeClosed from "../images/eyeClosedIcon.svg";
import EyeOpen from "../images/eyeOpenIcon.svg";

import SignUp from "../components/SignUp";
import ForgotPass from "../components/ForgotPass";
import { login } from "../actions/member";
import { connect } from "react-redux";
import Footer from "./Footer";
import { MainButton } from "./Buttons/MainButton/MainButton";

class LandingPageDesignWeb extends Component {
  lastFetchId = 0;
  startMyTeledoc = "";
  valueInputFindDoctorLocation = "";

  state = {
    isShowPanel: false,
    isShowPanelForDoctor: false,
    isdisplayShopPlansContent: false,
    isdisplayFindDoctorsLocations: false,

    isShowPanelSearchNews: false,
    isCollapseCoronapanel: false,
    fetchInputMyTeledoc: false,
    isCheckReCapchaCheckbox: false,
    isClickCheckReCapchaCheckbox: false,
    statecard: "",
    titleModalFindDoctorLocation: "",
    visibleSignUp: false,
    visibleForgot: false,
    visibleModalSignIn: false,
    data: [],
    valueSearchNews: [],
    fetching: false,
  };

  showModalSignIn = () => {
    this.setState({
      visibleModalSignIn: true,
    });
  };

  handleOkSignIn = (e) => {
    console.log(e);
    this.setState({
      visibleModalSignIn: false,
    });
  };

  handleCancelSignIn = (e) => {
    this.setState({
      visibleModalSignIn: false,
    });
  };

  handleSubmit(values) {
    const { login } = this.props;
    login(values).then((result) => {
      const { isSuccess, err } = result;

      if (isSuccess) {
        this.props.history.push("/manage/circle-user");
      } else {
        message.warn(err.message);
      }
    });
  }

  handleShowModal(name, value) {
    this.setState({
      [name]: value,
    });
  }

  handleResgiterSuccess() {
    this.handleShowModal("visibleSignUp", false);
    message.success("You have been register account success !");
    this.props.history.push("/manage/circle-user");
  }

  handleForgotPassSuccess() {
    this.handleShowModal("visibleForgot", false);
    message.success(
      "You have been reset account success, please check your email !"
    );
  }

  render() {
    const { visibleSignUp, visibleForgot } = this.state;
    const {
      Children,
      match: { path },
    } = this.props;
    console.log(path);
    return (
      // HEADER
      <Row>
        <Col
          xs={{ span: 0 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xxl={{ span: 24 }}
          style={{
            margin: 0,
            backgroundColor: colors.gencWhite,
            color: colors.gencGrey,
          }}
        >
          <Row className="header-container">
            <Col
              xs={{ span: 0 }}
              sm={{ span: 8 }}
              md={{ span: 7 }}
              lg={{ span: 7 }}
              xl={{ span: 7 }}
              xxl={{ span: 6 }}
              className="logo-container"
            >
              <a href="/">
                <img
                  className="logo-image"
                  alt="img"
                  shape="square"
                  src={logo_Final}
                />
              </a>
            </Col>
            <Col
              xs={{ span: 0 }}
              sm={{ span: 16 }}
              md={{ span: 17 }}
              lg={{ span: 17 }}
              xl={{ span: 17 }}
              xxl={{ span: 18 }}
              className="navs"
            >
              <a
                href="/how-it-works"
                type="primary"
                shape="round"
                size="large"
                className="header-nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push("/how-it-works");
                }}
                style={{
                  textDecoration: "none",
                  //TODO: This is super hacky lol
                  color:
                    path === "/how-it-works" ? colors.gencRed : colors.gencGrey,
                }}
              >
                How It Works
              </a>
              <a
                // onClick={}
                href="/our-team"
                type="primary"
                shape="round"
                size="large"
                className="header-nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push("/our-team");
                }}
                style={{
                  textDecoration: "none",
                  color:
                    path === "/our-team" ? colors.gencRed : colors.gencGrey,
                }}
              >
                Our Team
              </a>
              <a
                // onClick={}
                href="/contact-us"
                type="primary"
                shape="round"
                size="large"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push("/contact-us");
                }}
                className="header-nav-link"
                style={{
                  textDecoration: "none",
                  color:
                    path === "/contact-us" ? colors.gencRed : colors.gencGrey,
                }}
              >
                Contact Us
              </a>
              <MainButton text={"Sign In"} onClick={this.showModalSignIn} />
              {/* <Button
                onClick={this.showModalSignIn}
                type="primary"
                shape="round"
                size="large"
                // style={{
                //   background: colors.gencRed,
                //   borderColor: colors.gencRed,
                // }}
              >
                Sign in
              </Button> */}

              <Modal
                title=""
                visible={this.state.visibleModalSignIn}
                onOk={this.handleOkSignIn}
                onCancel={this.handleCancelSignIn}
                footer={null}
                className="modalSignInClass"
                style={{ borderRadius: "15px" }}
              >
                <Form
                  onFinish={(values) => {
                    this.handleSubmit(values);
                  }}
                  layout="vertical"
                  className="formSignInClass"
                  style={{ width: "100%" }}
                >
                  <div className="text-center" style={{ margin: 0 }}>
                    <h4 style={{ color: colors.gencBlue }}>
                      Sign in to your GenC Space
                    </h4>
                    <p style={{ fontSize: "16px", color: "#221F1F" }}>
                      Enter your email address and password
                    </p>
                  </div>
                  <FormItem
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                      {
                        required: true,
                        message: "Please input your E-mail!",
                      },
                    ]}
                    label={
                      <label
                        style={{
                          color: colors.gencGrey,
                          fontSize: "16px",
                          fontWeight: "400",
                          margin: 0,
                        }}
                      >
                        Email
                      </label>
                    }
                    style={{ width: "100%" }}
                  >
                    <Input
                      size="large"
                      placeholder="Email"
                      // prefix={<MailOutlined />}
                    />
                  </FormItem>
                  <FormItem
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                    label={
                      <label
                        style={{
                          color: colors.gencGrey,
                          fontSize: "16px",
                          fontWeight: "400",
                          margin: 0,
                        }}
                      >
                        Password
                      </label>
                    }
                    style={{ width: "100%" }}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Password"
                      iconRender={(visible) =>
                        visible ? (
                          <img src={EyeOpen} alt="eye open" />
                        ) : (
                          <img src={EyeClosed} alt="eye closed" />
                        )
                      }
                      // prefix={<LockOutlined />}
                    />
                  </FormItem>
                  <div className="d-flex justify-content-between">
                    {/* TODO: Remembe me toggle & functionality */}
                    <p>Remember me</p>
                    <p>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleShowModal("visibleForgot", true);
                          this.handleCancelSignIn();
                        }}
                        href="#"
                        style={{ color: colors.gencGrey }}
                      >
                        Forgot your password?
                      </a>
                    </p>
                  </div>
                  <div
                    className="ant-row ant-form-item"
                    style={{
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      padding: "0.1em",
                    }}
                  >
                    <Button
                      htmlType="submit"
                      type="primary"
                      block
                      style={{
                        border: "none",
                        backgroundColor: colors.gencRed,
                        fontWeight: "700",
                        fontSize: "20px",
                        borderRadius: "10px",
                        width: "70%",
                        height: "56px",
                      }}
                    >
                      Sign In
                    </Button>
                  </div>
                  <div className="text-center">
                    <p style={{ color: colors.gencBlack }}>
                      If you don't have an account{" "}
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleShowModal("visibleSignUp", true);
                          this.handleCancelSignIn();
                        }}
                        href="#"
                        style={{ color: colors.gencRed }}
                      >
                        Register now!
                      </a>
                    </p>
                  </div>
                </Form>
              </Modal>
              <Modal
                // title="Create your GenC Space"
                visible={visibleSignUp}
                className="modalSignInClass"
                footer={[]}
                onCancel={() => this.handleShowModal("visibleSignUp", false)}
              >
                <SignUp
                  handleResgiterSuccess={() => {
                    this.handleResgiterSuccess();
                  }}
                />
              </Modal>
              <Modal
                // title="Forgot your password"
                visible={visibleForgot}
                className="modalSignInClass"
                footer={[]}
                onCancel={() => this.handleShowModal("visibleForgot", false)}
                style={{ color: colors.gencBlue }}
              >
                <ForgotPass
                  handleForgotPassSuccess={() => {
                    this.handleForgotPassSuccess();
                  }}
                />
              </Modal>
            </Col>
          </Row>
          {/* HEADER-END */}
          <Children showModalSignIn={this.showModalSignIn} {...this.props} />
          <Footer />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  member: state.member || {},
});

const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => login(data),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPageDesignWeb);
